import { render, staticRenderFns } from "./SolutionPage.vue?vue&type=template&id=6b921e0c&"
import script from "./SolutionPage.vue?vue&type=script&lang=js&"
export * from "./SolutionPage.vue?vue&type=script&lang=js&"
import style0 from "./SolutionPage.vue?vue&type=style&index=0&id=6b921e0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports